import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Invoice-index-1992f2b8313869d72-1'),
    routerUrl: '/Invoice',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Invoice')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Invoice-index-1992f2b8313869d72-2'),
        routerUrl: '/InvoiceForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./InvoiceForm')),
      },
      //$MORE$
    ],
  },
];
